import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import { centrifugeConnect } from '@/api/centrifuge'
// импорт api
import usersApi from '@/api/usersApi'

// импорт модулей
import alert from '@/store/modules/alert'
import dictionaries from './modules/dictionaries'
// сотрудники
import userRoles from './modules/Users/user-roles'
import userCreatePage from './modules/Users/user-create-page'
import userUpdatePage from './modules/Users/user-update-page'
import userListPage from './modules/Users/user-list-page'
import subordinatesListPage from './modules/Users/subordinates-list-page'
import departmentsTreePage from './modules/Users/departments-tree-page'
import departmentCreatePage from './modules/Users/department-create-page'
import userGroupsPage from './modules/Users/user-groups-page'
import userCalendar from './modules/Users/user-calendar'
import userHours from './modules/Users/user-hours'

// справочники
import positionListPage from './modules/Users/Directories/position-list-page'
import employmentListPage from './modules/Users/Directories/employment-list-page'
import statusListPage from './modules/Users/Directories/status-list-page'
import scheduleListPage from './modules/Users/Directories/schedule-list-page'
import handbook from '@/store/modules/handbook'

// лента новостей
import feedPage from './modules/Feed/feed-page'
// боковое доп меню
import asideMenu from './modules/Menu/aside-menu'
// уведомления
import notificationWidget from './modules/Notification/notification-widget'
// чаты
import dialogWidget from './modules/Dialog/dialog-widget'
// отчеты
import usersReportPage from './modules/Reports/users-report-page'
// задачи
import taskListPage from './modules/Tasks/task-list-page'
import taskInfoPage from './modules/Tasks/task-info-page'
// договоры
import contract from '@/store/modules/Contract'
import contractListPage from './modules/Contract/contracts-list-page'
import contractTypeListPage from './modules/Contract/contract-type-list-page'
import contractStageListPage from './modules/Contract/contract-stage-list-page'
import contractStatusListPage from './modules/Contract/contract-status-list-page'
import contractProjectListPage from './modules/Contract/contract-project-list-page'
// контрагенты
import contractorListPage from './modules/Contractor/contractor-list-page'
import contractorUpdatePage from './modules/Contractor/contractor-update-page'
import contractorFormListPage from './modules/Contractor/contractor-form-list-page'
import contractorStatusListPage from './modules/Contractor/contractor-status-list-page'
import contractorTypeListPage from './modules/Contractor/contractor-type-list-page'
// ПВХ
import pvhOrderListPage from './modules/Pvh/pvh-order-list-page'
import pvhOrderUpdatePage from './modules/Pvh/pvh-order-update-page'
import pvhDeliveryTypeList from './modules/Pvh/pvh-delivery-type-list-page'
import pvhInformTypeList from './modules/Pvh/pvh-inform-type-list-page'
import pvhCostTypeList from './modules/Pvh/pvh-cost-type-list-page'
import pvhIncomingTypeList from './modules/Pvh/pvh-incoming-type-list-page'
import pvhClientList from './modules/Pvh/pvh-client-list-page'
import pvhClientUpdate from './modules/Pvh/pvh-client-update-page'
import pvhRoleList from './modules/Pvh/pvh-role-list-page'
import pvhRoleUpdate from './modules/Pvh/pvh-role-update-page'
import pvhStatusList from './modules/Pvh/pvh-status-list-page'
import pvhStatusUpdate from './modules/Pvh/pvh-status-update-page'
import pvhOrderTypeList from './modules/Pvh/pvh-order-type-list-page'
import pvhOrderTypeUpdate from './modules/Pvh/pvh-order-type-update-page'
// листы согласования
import approve from '@/store/modules/Approve'
import approveListPage from './modules/Approve/approve-list-page'
// выгрузки
import unloadingListPage from './modules/Unloading/unloading-list-page'
// логистика
import logistic from '@/store/modules/logistic'
// эдо
import edoReestrList from './modules/Edo/edo-reester-list'
import edoChangelog from './modules/Edo/edo-changelog'
// ПТО+Сметный
import pto from '@/store/modules/pto'
import { PTO_HANDBOOK_LIST } from '@/data/pto/handbookData'
import { initServiceWorker } from '@/utils/initServiceWorker'
import { instance } from '@/api/defaultApi'
import { vuexSendingRequestBase } from '@/store/compositionV2/utils/sendingRequest'

Vue.use(Vuex)

/* в авторизацию устанавливается токен от залогиненного сотрудника */
export const configMultipart = { headers: { 'Content-Type': 'multipart/form-data', Accept: 'application/json', Authorization: 'Bearer api_key' } }
export const config = { headers: { Accept: 'application/json', Authorization: 'Bearer api_key' } }

export const url = process.env.VUE_APP_API_URL

// Для скрытия модулей на продакшене
const isProd = url === 'https://backend.intex-mgn.ru/api'

export default new Vuex.Store({
  state: {
    appData: {
      authData: {
        login: '',
        password: '',
        /* login: 'admin@admin.ltd',
        password: 'Ghbdtn123', */
        validation: {
          login: {},
          password: {}
        }
      },
      loginErrorIsActive: false,
      currentUser: {
        id: null,
        api_key: null,
        centrifugo_token: null,
        logged_in: false
      },
      currentUserData: {
        id: null,
        email: null,
        avatar: null,
        full_name: 'Вход не выполнен',
        isLoading: true,
        menu: {
          is_active: false,
          list: []
        }
      },
      mediaBreakpoint: 'desktop',
      // флаг хранит тип ос IOS или default
      userAgent: 'default',
      mainMenu: {
        // флаг для мобилки отвечает за выезд меню
        is_active_mobile: false,
        // а флаг активации отвечает за показ списка плагинов внутри меню
        is_active: true,
        list: []
      },
      /* меню формируются через мутацию */
      sectionMenus: {
        usersMenu: {},
        contractMenu: {},
        contractorsMenu: {},
        pvhMenu: {},
        approveMenu: {},
        unloadingMenu: {},
        logisticsMenu: {},
        edoMenu: {},
        ptoMenu: {},
        standardsMenu: {},
        directoriesMenu: {},
        reportsMenu: {}
      },
      activeMenu: {}
    },
    ...vuexSendingRequestBase.createState()
  },
  getters: {
    // Авторизация
    authData: state => state.appData.authData,
    currentUser: state => {
      return state.appData.currentUser
    },
    currentUserData: state => state.appData.currentUserData,
    currentUserEmail: state => state.appData.currentUserData?.email,
    loginErrorIsActive: state => state.appData.loginErrorIsActive,
    // Меню
    mainMenu: state => state.appData.mainMenu,
    activeMenu: state => state.appData.activeMenu,

    getMediaBreakpoint: state => state.appData.mediaBreakpoint,
    getUserAgent: state => state.appData.userAgent
  },
  mutations: {
    // АВТОРИЗАЦИЯ
    SET_AUTH_LOGIN: (state, login) => {
      state.appData.authData.login = login.replace(/\s/g, '')
    },
    SET_AUTH_PASSWORD: (state, password) => {
      state.appData.authData.password = password.replace(/\s/g, '')
    },
    '[index] CLEAR_LOGIN_FORM': (state) => {
      state.appData.authData.login = ''
      state.appData.authData.password = ''
    },
    SET_AUTH_VALIDATION: (state, errors) => {
      if (errors) {
        if (errors.email) {
          state.appData.authData.validation.login = {
            type: 'error',
            message: errors.email[0]
          }
        }
        if (errors.password) {
          state.appData.authData.validation.password = {
            type: 'error',
            message: errors.password[0]
          }
        }
      }
    },
    LOGIN_FORM_CLEAR_VALIDATION: (state, input) => {
      if (input === 'login') {
        state.appData.authData.validation.login = {}
      } else if (input === 'password') {
        state.appData.authData.validation.password = {}
      }
    },
    // записываем данные о залогиненом пользователе в стейт и localStorage
    LOG_IN: (state, user) => {
      const currentUser = {
        id: user.id,
        api_key: user.api_key,
        centrifugo_token: user.centrifugo_token,
        /* role: user.role ? user.role : null, */
        // TODO: вернуть когда Паша включит роли
        role: 'administrator',
        logged_in: true
      }
      /* обновляем конфиги запросов */
      configMultipart.headers.Authorization = `Bearer ${user.api_key}`
      config.headers.Authorization = `Bearer ${user.api_key}`

      state.appData.currentUser = currentUser
      localStorage.currentUserId = currentUser.id
      // сохраняем ключ в localStorage (может быть не верное решение с точки зрения безопасности)
      localStorage.currentUserKey = currentUser.api_key
      localStorage.currentUserToken = currentUser.centrifugo_token
      localStorage.currentUserLogged = currentUser.logged_in
    },
    GET_CURRENT_USER_DATA: (state, data) => {
      state.appData.currentUserData.id = data.id
      state.appData.currentUserData.email = data.email
      state.appData.currentUserData.full_name = data.profile && (data.profile.name || data.profile.surname) ? `${data.profile.surname ? data.profile.surname : ''} ${data.profile.name ? data.profile.name : ''}` : 'Без имени'
      state.appData.currentUserData.avatar = (data.avatar && data.avatar.file_size) ? data.avatar.url : null
      state.appData.currentUserData.menu.list = [
        {
          title: 'Личные данные',
          link: `/user/info/${data.id}/personal`
        }
      ]
      state.appData.currentUserData.isLoading = false
    },
    GET_CURRENT_USER_DATA_FAILURE: (state) => {
      state.appData.currentUserData.isLoading = false
    },
    LOG_OUT: (state) => {
      // устанавливаем дефолтные значения текущего пользователя
      state.appData.currentUser = {
        id: null,
        api_key: null,
        centrifugo_token: null,
        logged_in: false
      }
      // устанавливаем дефолтные значения данных текущего пользователя
      state.appData.currentUserData = {
        id: null,
        avatar: null,
        full_name: 'Вход не выполнен',
        isLoading: true,
        menu: {
          // ставим меню в положение active так-как при нажатии оно сменяется на противоположное и при логауте остается открытым
          is_active: true,
          list: []
        }
      }
      localStorage.removeItem('currentUserId')
      localStorage.removeItem('currentUserSU')
      localStorage.removeItem('currentUserKey')
      localStorage.removeItem('currentUserToken')
      localStorage.removeItem('currentUserLogged')
    },
    SHOW_LOGIN_ERROR_MESSAGE: state => {
      state.appData.loginErrorIsActive = true
    },
    HIDE_LOGIN_ERROR_MESSAGE: state => {
      state.appData.loginErrorIsActive = false
    },

    // МЕНЮ
    TOGGLE_HEADER_MENU: (state) => {
      state.appData.currentUserData.menu.is_active = !state.appData.currentUserData.menu.is_active
    },
    CLOSE_HEADER_MENU: (state) => {
      state.appData.currentUserData.menu.is_active = false
    },
    MAIN_MENU_INITIALIZE: (state, getters) => { // передал getters из actions
      state.appData.mainMenu.list = [
        {
          icon: '/img/svg/users_icon.svg',
          title: 'Сотрудники',
          route: 'usersMenu',
          colorFirst: '#E6B537',
          colorSecond: '#EF4F3D'
        }
      ]
      const roleAccessContracts = state.userRoles.contracts.access
      if (roleAccessContracts) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/contract_icon.svg',
          title: 'Договоры',
          route: 'contractMenu',
          colorFirst: '#DA60A3',
          colorSecond: '#EF424D'
        })
      }

      const roleAccessContractors = state.userRoles.contractors.access
      if (roleAccessContractors) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/contractor_icon.svg',
          title: 'Контрагенты',
          route: 'contractorsMenu',
          colorFirst: '#E7205B',
          colorSecond: '#4F26A8'
        })
      }

      const roleAccessPvh = state.userRoles.pvh.access
      if (!isProd && roleAccessPvh) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/pvh_icon.svg',
          title: 'ПВХ',
          route: 'pvhMenu',
          colorFirst: '#45B0D1',
          colorSecond: '#37C8B3'
        })
      }

      const roleAccessApprove = state.userRoles.approve.access
      if (roleAccessApprove) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/approve_icon.svg',
          title: 'Листы согласования',
          route: 'approveMenu',
          colorFirst: '#60BF9C',
          colorSecond: '#97B629'
        })
      }

      const roleAccessLogistic = state.userRoles.logistic.access
      if (!isProd && roleAccessLogistic) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/logistics_icon.svg',
          title: 'Логистика',
          route: 'logisticsMenu',
          colorFirst: '#E5B537',
          colorSecond: '#EF4F3D'
        })
      }

      // ToDo Скрытие меню
      const roleAccessEdo = state.userRoles.edo.access
      if (!isProd && roleAccessEdo) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/edo_icon.svg',
          title: 'ЭДО',
          route: 'edoMenu',
          colorFirst: '#60BF9C',
          colorSecond: '#97B629'
        })
      }

      const roleAccessPto = getters.rightsPtoAll || getters.rightsPtoRead
      if (!isProd && roleAccessPto) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/pto_icon.svg',
          title: 'ПТО+Сметный',
          route: 'ptoMenu',
          colorFirst: '#DA60A3',
          colorSecond: '#EF424D'
        })
      }

      const roleAccessStandards = state.userRoles.standards.access
      if (!isProd && roleAccessStandards) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/standards_icon.svg',
          title: 'Орг. стандарты',
          route: 'standardsMenu',
          colorFirst: '#45B0D1',
          colorSecond: '#37C8B3'
        })
      }
    },
    MENU_INITIALIZE: (state, getters) => {
      const userId = state.appData.currentUser.id || localStorage.getItem('currentUserId')
      const roleAccessGroups = state.userRoles.userGroups.access
      const roleAccessSubordinates = state.userRoles.users.subordinates
      const roleAccessDirectories = state.userRoles.directories.access

      const usersMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/users_icon.svg',
          colorFirst: '#E6B537',
          colorSecond: '#EF4F3D'
        },
        title: 'Сотрудники',
        subtitle: null,
        list: [
          {
            title: 'Все сотрудники',
            link: '/user/list'
          },
          {
            title: 'Структура организации',
            link: '/departments/tree'
          }
        ]
      }

      if (!getters.rightsUsersRead) {
        usersMenu.list.splice(0, 1)
      }

      state.appData.sectionMenus.usersMenu = usersMenu
      if (roleAccessSubordinates) {
        state.appData.sectionMenus.usersMenu.list.push({
          title: 'Мои сотрудники',
          link: `/user/subordinates-list/${userId}`,
          is_parent: false
        })
      }
      if (roleAccessGroups) {
        state.appData.sectionMenus.usersMenu.list.push({
          title: 'Группы',
          link: '/user/groups',
          is_parent: false
        })
      }
      if (roleAccessDirectories) {
        state.appData.sectionMenus.usersMenu.list.push({
          title: 'Справочники',
          link: null,
          sub_menu: 'directoriesMenu'
        })
      }

      // TODO: если юзер не имеет доступов к разделам - сделать так, чтобы он не мог переходить по этим роутам
      state.appData.sectionMenus.contractMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/section-img_icon.svg',
          colorFirst: '#DA60A3',
          colorSecond: '#EF424D'
        },
        title: 'Договоры',
        subtitle: null,
        list: [
          {
            title: 'Договоры',
            link: '/contracts/list'
          },
          {
            title: 'Стадии договора',
            link: '/contracts/stages'
          },
          {
            title: 'Статусы договора',
            link: '/contracts/status'
          },
          {
            title: 'Типы договора',
            link: '/contracts/types'
          },
          {
            title: 'Проекты',
            link: '/contracts/projects'
          },
          {
            title: 'Журнал изменений',
            link: '/contracts/changelog'
          }
        ]
      }
      state.appData.sectionMenus.contractorsMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/contractor_icon.svg',
          colorFirst: '#E7205B',
          colorSecond: '#4F26A8'
        },
        title: 'Контрагенты',
        subtitle: null,
        list: [
          {
            title: 'Контрагенты',
            link: '/contractors/list'
          },
          {
            title: 'Статусы контрагента',
            link: '/contractors/status'
          },
          {
            title: 'Типы контрагентов',
            link: '/contractors/types'
          },
          {
            title: 'Орг. прав. формы предприятия',
            link: '/contractors/forms'
          }
        ]
      }
      state.appData.sectionMenus.pvhMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/pvh_icon.svg',
          colorFirst: '#45B0D1',
          colorSecond: '#37C8B3'
        },
        title: 'ПВХ',
        subtitle: null,
        list: [
          {
            title: 'Заказы / заявки',
            link: '/pvh/order/list'
          },
          {
            title: 'Клиенты / контакты',
            link: '/pvh/client/list'
          },
          {
            title: 'Способы доставки',
            link: '/pvh/delivery-types'
          },
          {
            title: 'Типы информирования клиентов',
            link: '/pvh/inform-types'
          },
          {
            title: 'Роли сотрудников',
            link: '/pvh/roles/list'
          },
          {
            title: 'Статусы',
            link: '/pvh/status/list'
          },
          {
            title: 'Типы заказов',
            link: '/pvh/order-type/list'
          },
          {
            title: 'Типы расходов',
            link: '/pvh/cost-types'
          },
          {
            title: 'Типы приходов',
            link: '/pvh/incoming-types'
          }
        ]
      }
      state.appData.sectionMenus.approveMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/approve_icon.svg',
          colorFirst: '#60BF9C',
          colorSecond: '#97B629'
        },
        title: 'Листы согласования',
        subtitle: null,
        list: [
          {
            title: 'Список',
            link: '/approve/list'
          }
        ]
      }
      state.appData.sectionMenus.unloadingMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/unloading_icon.svg',
          colorFirst: '#60BF9C',
          colorSecond: '#97B629'
        },
        title: 'Выгрузки',
        subtitle: null,
        list: [
          {
            title: 'Список выгрузок',
            link: '/unloading/list'
          }
        ]
      }
      state.appData.sectionMenus.logisticsMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/logistics_icon.svg',
          colorFirst: '#E5B537',
          colorSecond: '#EF4F3D'
        },
        title: 'Логистика',
        subtitle: null,
        list: [
          {
            title: 'Путевые листы',
            link: '/logistics/waybills'
          },
          {
            title: 'Топливо',
            link: '/logistics/fuel'
          },
          {
            title: 'Объекты',
            link: '/logistics/objects'
          },
          {
            title: 'Транспорт',
            link: '/logistics/transport'
          },
          {
            title: 'Водители',
            link: '/logistics/drivers'
          },
          {
            title: 'Отчеты',
            link: '/logistics/reports'
          }
        ]
      }
      state.appData.sectionMenus.edoMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/edo_icon.svg',
          colorFirst: '#60BF9C',
          colorSecond: '#97B629'
        },
        title: 'ЭДО',
        subtitle: null,
        list: [
          {
            title: 'Реестр ЭДО',
            link: '/edo/reestr'
          },
          {
            title: 'Журнал изменений',
            link: '/edo/changelog'
          }
        ]
      }
      state.appData.sectionMenus.ptoMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/pto_icon.svg',
          colorFirst: '#DA60A3',
          colorSecond: '#EF424D'
        },
        title: 'ПТО+Сметный',
        subtitle: null,
        list: [
          {
            title: 'Реестр строек',
            link: '/pto/building-register'
          },
          {
            title: 'Реестр объектов',
            link: '/pto/object'
          },
          {
            title: 'Реестр проектов',
            link: '/pto/project'
          },
          {
            title: 'Журнал изменений',
            link: '/pto/changelog'
          },
          {
            title: 'Справочники',
            link: null,
            sub_menu: 'ptoMenuHandbook'
          }
        ]
      }
      state.appData.sectionMenus.ptoMenuHandbook = {
        is_root: false,
        parentMenu: 'ptoMenu',
        icon: null,
        title: 'Справочники',
        subtitle: null,
        list: Object.values(PTO_HANDBOOK_LIST)
          .map(data => ({
            title: data.pageTitle,
            link: data.link
          }))
      }

      state.appData.sectionMenus.directoriesMenu = {
        is_root: false,
        parentMenu: 'usersMenu',
        icon: null,
        title: 'Справочники',
        subtitle: null,
        list: [
          {
            title: 'Должности',
            link: '/user/directories/positions'
          },
          {
            title: 'Виды занятости',
            link: '/user/directories/employments'
          },
          {
            title: 'Статусы',
            link: '/user/directories/statuses'
          },
          {
            title: 'Графики работы',
            link: '/user/directories/schedules'
          }
        ]
      }
      state.appData.sectionMenus.reportsMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/section-img_icon.svg',
          colorFirst: '#363b3a',
          colorSecond: '#8d9180'
        },
        title: 'Отчеты',
        subtitle: null,
        list: [
          {
            title: 'Отчет по сотрудникам',
            link: '/reports/users'
          }
        ]
      }
      state.appData.sectionMenus.standardsMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/standards_icon.svg',
          colorFirst: '#45B0D1',
          colorSecond: '#37C8B3'
        },
        title: 'Орг. стандарты',
        subtitle: null,
        list: [
          {
            title: 'Приказы',
            link: '/standards/decrees'
          },
          {
            title: 'Организующие стандарты',
            link: '/standards/org-standards'
          },
          {
            title: 'Папка “Штатного сотрудника”',
            link: '/standards/worker-folder'
          },
          {
            title: 'Папка “Должности”',
            link: '/standards/jobs-folder'
          }
        ]
      }
    },
    SET_CURRENT_MENU: (state, currentRootPath) => {
      const usersMenu = state.appData.sectionMenus.usersMenu
      const directoriesMenu = state.appData.sectionMenus.directoriesMenu
      const reportsMenu = state.appData.sectionMenus.reportsMenu
      const contractMenu = state.appData.sectionMenus.contractMenu
      const contractorsMenu = state.appData.sectionMenus.contractorsMenu
      const pvhMenu = state.appData.sectionMenus.pvhMenu
      const unloadingMenu = state.appData.sectionMenus.unloadingMenu
      const logisticsMenu = state.appData.sectionMenus.logisticsMenu
      const edoMenu = state.appData.sectionMenus.edoMenu
      const ptoMenu = state.appData.sectionMenus.ptoMenu
      const standardsMenu = state.appData.sectionMenus.standardsMenu

      state.appData.mainMenu.is_active = false
      switch (currentRootPath) {
        case 'user':
          state.appData.activeMenu = usersMenu
          break
        case 'directories':
          state.appData.activeMenu = directoriesMenu
          break
        case 'reports':
          state.appData.activeMenu = reportsMenu
          break
        case 'contracts':
          state.appData.activeMenu = contractMenu
          break
        case 'contractors':
          state.appData.activeMenu = contractorsMenu
          break
        case 'pvh':
          state.appData.activeMenu = pvhMenu
          break
        case 'unloading':
          state.appData.activeMenu = unloadingMenu
          break
        case 'logistics':
          state.appData.activeMenu = logisticsMenu
          break
        case 'edo':
          state.appData.activeMenu = edoMenu
          break
        case 'pto':
          state.appData.activeMenu = ptoMenu
          break
        case 'standards':
          state.appData.activeMenu = standardsMenu
          break
        default:
          state.appData.mainMenu.is_active = true
          break
      }
    },
    TOGGLE_MAIN_MENU: (state) => {
      state.appData.mainMenu.is_active = true
    },
    TOGGLE_MAIN_MENU_MOBILE: (state) => {
      state.appData.mainMenu.is_active_mobile = !state.appData.mainMenu.is_active_mobile
    },
    CLOSE_MAIN_MENU_MOBILE: (state) => {
      state.appData.mainMenu.is_active_mobile = false
    },
    SWITCH_MENU: (state, { data, getters }) => {
      const currentRouteName = router.currentRoute.name

      switch (data.menu) {
        case 'usersMenu':
          if (currentRouteName !== 'UserList') {
            if (!getters.rightsUsersRead) {
              router.push({ name: 'DepartmentsTree' })
            } else {
              router.push({ name: 'UserList' })
            }
          }
          break
        case 'directoriesMenu':
          if (currentRouteName !== 'PositionList') {
            router.push({ name: 'PositionList' })
          }
          break
        case 'reportsMenu':
          if (currentRouteName !== 'UsersReport') {
            router.push({ name: 'UsersReport' })
          }
          break
        case 'contractMenu':
          if (currentRouteName !== 'ContractList') {
            router.push({ name: 'ContractList' })
          }
          break
        case 'contractorsMenu':
          if (currentRouteName !== 'ContractorList') {
            router.push({ name: 'ContractorList' })
          }
          break
        case 'pvhMenu':
          if (currentRouteName !== 'PvhOrderList') {
            router.push({ name: 'PvhOrderList' })
          }
          break
        case 'approveMenu':
          if (currentRouteName !== 'ApproveList_new') {
            router.push({ name: 'ApproveList_new' })
          }
          break
        case 'unloadingMenu':
          if (currentRouteName !== 'UnloadingList') {
            router.push({ name: 'UnloadingList' })
          }
          break
        case 'logisticsMenu':
          if (currentRouteName !== 'LogisticWaybillList') {
            router.push({ name: 'LogisticWaybillList' })
          }
          break
        case 'edoMenu':
          if (currentRouteName !== 'EdoReestrList') {
            router.push({ name: 'EdoReestrList' })
          }
          break
        case 'ptoMenu':
          if (currentRouteName !== 'Pto') {
            router.push({ name: 'Pto' })
          }
          break
        case 'standardsMenu':
          if (currentRouteName !== 'Standards') {
            router.push({ name: 'Standards' })
          }
          break
        default: break
      }
      state.appData.activeMenu = state.appData.sectionMenus[`${data.menu}`]
      if (!data.isSubmenu) {
        state.appData.mainMenu.is_active = !state.appData.mainMenu.is_active
      }
    },
    SET_CURRENT_MEDIA_BREAKPOINT: (state, breakpoint) => {
      state.appData.mediaBreakpoint = breakpoint
    },
    SET_CURRENT_USER_AGENT: (state, type) => {
      state.appData.userAgent = type
    },

    ...vuexSendingRequestBase.createMutations()
  },
  actions: {
    closeAllPopups ({ commit }) {
      switch (router.currentRoute.name) {
        case 'DepartmentsTree':
          commit('CLOSE_DEPARTMENTS_TREE_ITEM_POPUPS')
          break
        case 'UserDetail_calendarTab':
          commit('CLOSE_FEED_EVENT_MORE_USERS')
          break
        case 'Feed':
          commit('HIDE_FEED_MESSAGE_AREA')
          commit('CLOSE_FEED_MESSAGE_LINK_TOOLTIP')
          commit('CLOSE_FEED_MESSAGE_TAG_TOOLTIP')
          commit('CLOSE_FEED_MESSAGE_RECIPIENTS')
          commit('CLOSE_FEED_POST_CONTROLS')
          commit('CLOSE_FEED_FILTER')
          commit('CLOSE_FEED_EVENT_MORE_USERS')
          break
        case 'PositionList':
          commit('CLOSE_POSITION_LIST_CONTROLS')
          break
        case 'EmploymentList':
          commit('CLOSE_EMPLOYMENT_LIST_CONTROLS')
          break
        case 'StatusList':
          commit('CLOSE_STATUS_LIST_CONTROLS')
          break
        case 'ScheduleList':
          commit('CLOSE_SCHEDULE_LIST_CONTROLS')
          break
        case 'TaskList':
          commit('CLOSE_TASK_BOARD_COLOR_PICKER')
          commit('CLOSE_TASK_LIST_PAGE_LIST')
          commit('CLOSE_TASK_LIST_FILTER_DATE_CREATED')
          commit('CLOSE_TASK_LIST_FILTER_DATE_FINISH')
          commit('CLOSE_TASK_LIST_FILTER_LIST')
          commit('CLOSE_TASK_LIST_ITEMS_CONTROLS')
          commit('CLOSE_TASK_BOARD_COLUMN_CONTROLS')
          commit('CLOSE_TASK_BOARD_NEW_COLUMN_FORM')
          break
        case 'TaskInfo':
          commit('CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
          commit('CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
          commit('CLOSE_TASK_INFO_COMMENTS_ITEMS_CONTROLS')
          commit('CLEAR_TASK_INFO_COMMENTS_VALID')
          break

          // договоры
        case 'ContractList':
          commit('contractListPage/TOGGLE_CONTRACTS_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractStageList':
          commit('TOGGLE_CONTRACTS_STAGE_LIST_ITEM_CONTROLS', null)
          commit('CLOSE_CONTRACTS_STAGE_LIST_PAGE_LIST')
          break
        case 'ContractTypeList':
          commit('contractTypeListPage/TOGGLE_CONTRACTS_TYPE_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractStatusList':
          commit('TOGGLE_CONTRACTS_STATUS_LIST_ITEM_CONTROLS', null)
          commit('CLOSE_CONTRACTS_STATUS_LIST_PAGE_LIST')
          break
        case 'ContractProjectList':
          commit('contractProjectListPage/TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_CONTROLS', null)
          break
          // /договоры

          // контрагенты
        case 'ContractorList':
          commit('contractorListPage/TOGGLE_CONTRACTORS_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractorsStatusList':
          commit('TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_CONTROLS', null)
          commit('CLOSE_CONTRACTORS_STATUS_LIST_PAGE_LIST')
          break
        case 'ContractorsTypeList':
          commit('TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_CONTROLS', null)
          commit('CLOSE_CONTRACTORS_TYPE_LIST_PAGE_LIST')
          break
        case 'ContractorsFormList':
          commit('TOGGLE_CONTRACTORS_FORMS_LIST_ITEM_CONTROLS', null)
          commit('CLOSE_CONTRACTORS_FORMS_LIST_PAGE_LIST')
          break
          // /контрагенты

          // pvh
        case 'PvhOrderUpdate_comment':
          commit('pvhOrderUpdatePage/[pvh] TOGGLE_ORDER_UPDATE_CONTROLS_COMMENT', null)
          break

          // листы согласования
        case 'ApproveUpdate_main':
          commit('approve/details/[approve] TOGGLE_ITEM_UPDATE_CONTROLS_COMMENT', null)
          break
        default: break
      }
      commit('CLOSE_HEADER_MENU')
    },

    // АВТОРИЗАЦИЯ
    setAuthLogin ({ commit }, login) {
      commit('SET_AUTH_LOGIN', login)
    },
    setAuthPassword ({ commit }, password) {
      commit('SET_AUTH_PASSWORD', password)
    },
    async logIn (context) {
      const authData = {
        email: context.state.appData.authData.login,
        password: context.state.appData.authData.password
      }

      const subscription = await initServiceWorker()

      return instance.post('users/auth', { ...authData, subscription }).then(response => {
        context.commit('LOG_IN', response.data.data)
        context.commit('[index] CLEAR_LOGIN_FORM')
        // при входе и выходе редиректим домой, чтобы не сбивалась логика инициализации меню,
        // так как оно в этих случаях не правильно устанавливает текущий раздел (мутация SET_CURRENT_MENU)
        if (router.currentRoute.path !== '/') {
          router.push({ path: '/' })
        }

        usersApi.getCurrentUser().then(response => {
          context.commit('GET_CURRENT_USER_DATA', response.data.data)
          context.commit('[roles] SET_RIGHTS', response.data.data.roles)
          context.dispatch('initialiseMenu')
          context.dispatch('[dictionaries] getTaskProcessTypes')
          context.dispatch('[dictionaries] getApproveProcessTypes')
        }).catch((error) => {
          console.log('Ошибка авторизации:', error.response)
          context.dispatch('logOut').then(() => {
            context.commit('GET_CURRENT_USER_DATA_FAILURE')
            context.commit('SHOW_LOGIN_ERROR_MESSAGE')
          })
        })
        // запускаем запрос уведомлений
        this.dispatch('getAppNotifications')
        // запускаем пинги для обновления статуса онлайн
        this.dispatch('renewUserAuthTime')
        // подключаемся к центрифуге
        centrifugeConnect(context)
      }).catch(error => {
        if (error?.response?.data?.data?.message) {
          context.commit('SET_AUTH_VALIDATION', { email: [error.response.data.data.message] })
        } else if (error.response.data.result_code === 'UNTF') {
          context.commit('SET_AUTH_VALIDATION', { email: [error.response.data.result_message] })
        } else {
          context.commit('SET_AUTH_VALIDATION', error.response.data.errors)
        }
      })
    },
    // проверяем залогиненого пользователя при маунте App
    checkLoggedUser (context) {
      if (localStorage.currentUserId) {
        context.state.appData.currentUser.id = +localStorage.currentUserId
        context.state.appData.currentUser.api_key = localStorage.currentUserKey
        context.state.appData.currentUser.logged_in = localStorage.currentUserLogged

        configMultipart.headers.Authorization = `Bearer ${localStorage.currentUserKey}`
        config.headers.Authorization = `Bearer ${localStorage.currentUserKey}`

        usersApi.getCurrentUser().then(response => {
          context.commit('GET_CURRENT_USER_DATA', response.data.data)
          context.commit('[roles] SET_RIGHTS', response.data.data.roles)
          context.dispatch('initialiseMenu')
          // запускаем запрос уведомлений
          this.dispatch('getAppNotifications')
          // запускаем пинги для обновления статуса онлайн
          this.dispatch('renewUserAuthTime')
          // подключаемся к центрифуге
          centrifugeConnect(context)
        }).catch(() => {
          context.dispatch('logOut').then(() => {
            context.commit('GET_CURRENT_USER_DATA_FAILURE')
            context.commit('SHOW_LOGIN_ERROR_MESSAGE')
          })
        })
      }
    },
    logOut ({ commit }) {
      // при входе и выходе редиректим домой, чтобы не сбивалась логика инициализации меню,
      // так как оно в этих случаях не правильно устанавливает текущий раздел (мутация SET_CURRENT_MENU)
      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' })
      }
      commit('[index] CLEAR_LOGIN_FORM')
      commit('[roles] REMOVE_RIGHTS')
      commit('LOG_OUT')
    },
    loginFormClearValidation ({ commit }, input) {
      commit('LOGIN_FORM_CLEAR_VALIDATION', input)
    },
    renewUserAuthTime () {
      setInterval(() => {
        usersApi.renewAuthTime().then(response => {}).catch(error => {
          console.log('ошибка обновления даты авторизации юзера', error.response ? error.response : error)
        })
      }, 270000)
    },

    // МЕНЮ
    // выпадающее меню текущего пользователя
    toggleHeaderMenu ({ commit }) {
      commit('TOGGLE_HEADER_MENU')
    },
    // меню по дефолту
    initialiseMenu ({ commit, getters }) {
      const currentRootPath = router.currentRoute.path.split('/')[1]
      commit('MENU_INITIALIZE', getters)
      commit('MAIN_MENU_INITIALIZE', getters)
      commit('SET_CURRENT_MENU', currentRootPath)
    },
    toggleMainMenu ({ commit }) {
      commit('TOGGLE_MAIN_MENU')
    },
    switchMenu ({ commit, getters }, data) {
      commit('SWITCH_MENU', { data, getters })
    },

    setCurrentMediaBreakPoint ({ commit }) {
      if (window.matchMedia('(max-width: 580px)').matches) {
        commit('SET_CURRENT_MEDIA_BREAKPOINT', 'mobile_start')
      } else if (window.matchMedia('(max-width: 1080px)').matches) {
        commit('SET_CURRENT_MEDIA_BREAKPOINT', 'tablet_start')
      } else {
        commit('SET_CURRENT_MEDIA_BREAKPOINT', 'desktop')
      }
    },
    setCurrentUserAgent ({ commit }) {
      if (navigator.userAgent.toLowerCase().match(/(ipad|iphone)/) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        commit('SET_CURRENT_USER_AGENT', 'IOS')
      }
    }
  },
  modules: {
    alert,
    handbook,
    dictionaries,
    userRoles,
    userCreatePage,
    userUpdatePage,
    userListPage,
    userHours,
    subordinatesListPage,
    departmentsTreePage,
    departmentCreatePage,
    userGroupsPage,
    userCalendar,
    feedPage,
    asideMenu,
    positionListPage,
    employmentListPage,
    statusListPage,
    scheduleListPage,
    notificationWidget,
    dialogWidget,
    usersReportPage,
    taskListPage,
    taskInfoPage,
    contract,
    contractListPage,
    contractTypeListPage,
    contractStageListPage,
    contractStatusListPage,
    contractProjectListPage,
    contractorListPage,
    contractorUpdatePage,
    contractorFormListPage,
    contractorStatusListPage,
    contractorTypeListPage,
    pvhOrderListPage,
    pvhOrderUpdatePage,
    pvhDeliveryTypeList,
    pvhInformTypeList,
    pvhCostTypeList,
    pvhIncomingTypeList,
    pvhClientList,
    pvhClientUpdate,
    pvhRoleList,
    pvhRoleUpdate,
    pvhStatusList,
    pvhStatusUpdate,
    pvhOrderTypeList,
    pvhOrderTypeUpdate,
    approve,
    approveListPage,
    unloadingListPage,
    logistic,
    edoReestrList,
    edoChangelog,
    pto
  }
})
